// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"929259676e1cf854","4545":"bb316c81c50a5d4c"}[chunkId] + ".css";
};